import { jsx } from "react/jsx-runtime";
import constate from "constate";
import { useState, useEffect } from "react";
import { BulkRowActionsModal } from "../components/Modal/BulkRowActionsModal.js";
import { useModal } from "../hooks/useModal.js";
var ActionStatus = /* @__PURE__ */ ((ActionStatus2) => {
  ActionStatus2["inProgress"] = "InProgress";
  ActionStatus2["success"] = "Success";
  ActionStatus2["failed"] = "Failed";
  return ActionStatus2;
})(ActionStatus || {});
const useBulkRowActionsModalContext = () => {
  const [selectedAction, setSelectedAction] = useState();
  const [actionStatus, setActionStatus] = useState();
  const bulkRowActionsModal = useModal({
    onOpen: (args) => {
      setActionStatus(void 0);
      setSelectedAction(args.action);
    },
    modal: !selectedAction ? void 0 : (close) => /* @__PURE__ */ jsx(
      BulkRowActionsModal,
      {
        onCancel: close,
        onSubmit: selectedAction.action,
        text: selectedAction.modalText,
        closeModal: close,
        isSubmitting: actionStatus === "InProgress",
        hasError: actionStatus === "Failed"
        /* failed */
      }
    )
  });
  useEffect(() => {
    if (actionStatus === "Success") {
      bulkRowActionsModal.close();
    }
  }, [actionStatus, setActionStatus]);
  return {
    bulkRowActionsModal,
    setActionStatus
  };
};
const [BulkRowActionsProvider, useBulkRowActionsContext] = constate(
  useBulkRowActionsModalContext
);
export {
  ActionStatus,
  BulkRowActionsProvider,
  useBulkRowActionsContext,
  useBulkRowActionsModalContext
};
